module.exports = "/img/team-member-2.e95f3557.png";